module.exports = __webpack_public_path__ + "static/media/badge_card_bg.ac1d791a.svg";